import * as React from "react";
import { Tag } from "antd";
import { COLORS } from "@app/styles/consts";
import { TTL, TTL_LABELS } from "@ea/shared_types/types";
import { injectIntl, InjectedIntlProps } from "react-intl";

interface IStatusFieldProps {
  type: TTL;
}

const style = {
  cursor: "default",
};

const ApiKeyTTLField: React.FunctionComponent<IStatusFieldProps & InjectedIntlProps> = ({
  type,
  intl,
}) => {
  if (!type) {
    return null;
  }

  return (
    <Tag style={style} color={COLORS.TTL[type]}>
      {TTL_LABELS[type]}
    </Tag>
  );
};

export default injectIntl(ApiKeyTTLField);
